import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles } from '@material-ui/core';

import BlockStyleControls from './BlockStyles';
import InlineStyleControls from './InlineStyles';
import ImagePicker from './ImagePicker';
import ColorStyles from './ColorStyles';
import FontSize from './FontSize';
import Links from './Links'
import FieldInserts from './FieldInserts';

import { RichUtils } from 'draft-js';
import { toggleCustomInlineStyle } from 'draftjs-utils';
import { insertImage, insertEntityType } from '../utils';

import { toolbarStyles } from './styles';

function EditorToolbar (props) {

    const { editorState, handleChange, handleCustom, handleFocus, classes } = props;

    const toggleBlockType = (blockType) => handleChange(RichUtils.toggleBlockType(editorState, blockType));

    const toggleInlineStyle = (inlineStyle) => handleChange(RichUtils.toggleInlineStyle(editorState, inlineStyle));

    const toggleCustomStyle = (styleType, style) => handleCustom(toggleCustomInlineStyle(editorState, styleType, style));

    const uploadImage = (entityData) => handleChange(insertImage(editorState, entityData));

    const insertEntity = (data, type) => handleChange(insertEntityType(editorState, data, type))

    return (
        <Toolbar disableGutters className={classes.toolbar}>
            <InlineStyleControls
                editorState={editorState}
                onToggle={toggleInlineStyle}
            />
            <ColorStyles
                handleFocus={handleFocus}
                editorState={editorState}
                onToggle={toggleCustomStyle}
            />
            <div className={classes.divider} />
            <BlockStyleControls
                editorState={editorState}
                onToggle={toggleBlockType}
            />
            <div className={classes.divider} />
            <FontSize
                editorState={editorState}
                onToggle={toggleCustomStyle}
            />
            <Links
                insertEntity={insertEntity}
            />
            <ImagePicker
                editorState={editorState}
                uploadImage={uploadImage}
            />
            <FieldInserts
                insertEntity={insertEntity}
            />
        </Toolbar>
    );
}

export default withStyles(toolbarStyles)(EditorToolbar);
